import * as React from 'react'

export function Search(props: React.SVGProps<SVGSVGElement>) {
    return (
        <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M20.723 18.837h-.993l-.353-.34a8.14 8.14 0 0 0 1.975-5.32A8.176 8.176 0 0 0 13.176 5 8.176 8.176 0 0 0 5 13.176a8.176 8.176 0 0 0 8.176 8.176 8.14 8.14 0 0 0 5.32-1.975l.34.353v.993L25.127 27 27 25.126l-6.277-6.29Zm-7.547 0a5.653 5.653 0 0 1-5.66-5.66 5.653 5.653 0 0 1 5.66-5.661 5.653 5.653 0 0 1 5.66 5.66 5.653 5.653 0 0 1-5.66 5.66Z"
                fill="currentColor"
            />
        </svg>
    )
}
